export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.817 1.284a.623.623 0 010 .881l-4.55 4.551a.623.623 0 01-.882 0L.183 4.514a.623.623 0 11.881-.882l1.762 1.762 4.11-4.11a.623.623 0 01.881 0z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "8",
    "height": "8",
    "fill": "currentColor",
    "viewBox": "0 0 8 8"
  }
};